import React from "react";
import { Button, ButtonProps } from "@mui/material";
import { useFormContext } from "./FormContext";

interface FormSubmitButtonProps extends Omit<ButtonProps, "disabled"> {
  disabled?: boolean;
}

const FormSubmitButton: React.FC<FormSubmitButtonProps> = ({
  disabled = false,
  ...props
}) => {
  const { validationResult, isSubmitted } = useFormContext();

  return (
    <Button
      {...props}
      disabled={disabled || (isSubmitted && !validationResult.isValid)}
    />
  );
};

export default FormSubmitButton;
